import { render, staticRenderFns } from "./EventManagerTable.vue?vue&type=template&id=13867fa2"
import script from "./EventManagerTable.vue?vue&type=script&lang=js"
export * from "./EventManagerTable.vue?vue&type=script&lang=js"
import style0 from "./EventManagerTable.vue?vue&type=style&index=0&id=13867fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports